import UserRoles from "../../Constant/UserRoles";

function validateTextInput(inputText, label, required) {
  if (required && inputText.trim() === "") {
    return `${stripColon(label)} is required.`;
  }

  if (!isValidTextInput(inputText) && !label.toLowerCase().includes("email")) {
    return "Special characters are not allowed.";
  }

  if (
    label.toLowerCase().includes("day") ||
    label.toLowerCase().includes("rate")
  ) {
    return validateNumericInput(inputText, "Only numeric values are allowed.");
  }

  const VALID_NAME_LABELS = [
    "First Name :",
    "Last Name :",
    "Designation :",
  ].map((label) => label.trim().toLowerCase());

  const formattedLabel = label?.trim().toLowerCase();

  if (formattedLabel && VALID_NAME_LABELS.includes(formattedLabel)) {
    return validateName(inputText);
  }

  if (label.toLowerCase().includes("contact")) {
    const phoneNumberError = validatePhoneNumber(inputText);
    if (phoneNumberError) return phoneNumberError;
    return validateNumericInput(inputText, "Only numeric values are allowed.");
  }

  if (label.toLowerCase().includes("email")) {
    return validateEmail(inputText);
  }

  if (
    label.toLowerCase().includes("code") &&
    inputText &&
    inputText.length > 0
  ) {
    return validateAlphanumeric(inputText);
  }

  return null;
}

function stripColon(label) {
  return label.replace(":", "");
}

function validateNumericInput(inputText, errorMessage) {
  return isValidNumeric(inputText) ? null : errorMessage;
}

function validatePhoneNumber(inputText) {
  if (!isValidPhoneNumber(inputText)) {
    return "Please enter a valid 10-digit phone number.";
  }
  return null;
}

function validateEmail(inputText) {
  return isValidEmail(inputText) ? null : "Please enter a valid email address.";
}

function validateName(inputText) {
  return isValidName(inputText) ? null : "Only alphabetic characters allowed.";
}

function validateAlphanumeric(inputText) {
  return isValidCodeNumeric(inputText)
    ? null
    : "Please enter numeric value.";
}

// Function to validate alphanumeric value
function isValidCodeNumeric(text) {
  return /^[0-9]+$/.test(text);
}

// Function to validate special characters
function isValidTextInput(text) {
  return /^[a-zA-Z0-9 ]*$/.test(text);
}

// Function to validate email format
function isValidEmail(email) {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
}

function isValidName(name) {
  return /^[A-Za-z\s]+$/.test(name);
}
// Function to validate numeric value
function isValidNumeric(value) {
  return (
    !isNaN(value) &&
    value !== "" &&
    value !== null &&
    value.trim() !== "" &&
    /^\d+$/.test(value)
  );
}

// Function to validate phone number format
function isValidPhoneNumber(number) {
  return /^\d{10}$/.test(number);
}

// Function to validate select dropdown
function validateSelectDropdown(selectedOption, label, required, mode, masterType, roleName,
  talukaName
) {
  if(mode === 'Add' && selectedOption === 0  && masterType === "userMaster" && label === 'Taluka Name :' &&  roleName === UserRoles.UPHCMO && talukaName === ""){
    return null;
  }else {
    if (required && (!selectedOption || selectedOption.length === 0)) {
      return `${label.replace(":", "")} is required.`;
    }
  }
  return null;
}

// Function to validate file upload
function validateFileUpload(file, label, required) {
  if (required && !file) {
    return `${label.replace(":", "")} is required.`;
  }

  if (file && file.name) {
    const allowedExtensions = ["png", "jpg", "bmp", "msg", "eml", "pdf"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      return `Invalid file format.`;
    }
  }

  return null;
}

// Function to validate calendar input
function validateCalendarInput(dateString, label, required) {
  if (required && !dateString) {
    return `${label.replace(":", "")} is required.`;
  }

  return null;
}

// Function to validate translated input
function validateTranslatedInput(inputText, required) {
  if (required && inputText.trim() === "") {
    return "Translated text is required.";
  }

  return null;
}

function validatePasswordInput(password, label, required, mode) {
  if (mode === "Add") {
    if (required && (!password || password.trim() === "")) {
      return `${stripColon(label)} is required.`;
    }
  }
  return null;
}

export function validateReduxForm(
  type,
  param1,
  param2,
  param3,
  translate = false,
  mode,
  masterType,
  roleName,
  talukaName
) {
  if (type === "text" && translate) {
    return validateTranslatedInput(param1, param3);
  }
  switch (type) {
    case "text":
      return validateTextInput(param1, param2, param3);
    case "dropdown":
      return validateSelectDropdown(param1, param2, param3,mode,masterType,roleName,talukaName);
    case "multiselect":
      return validateSelectDropdown(param1, param2, param3);
    case "file":
      return validateFileUpload(param1, param2, param3);
    case "calendar":
      return validateCalendarInput(param1, param2, param3);
    case "password":
      return validatePasswordInput(param1, param2, param3, mode);
    default:
      return null;
  }
}
